import store from '../store';

export default async function entryFinancialProfile({ next, router }) {

    store.commit('SET_PRODUCT_TYPE', 'EntryFinancialProfile');
    if (store.getters.isAuthenticated)
        return router.push({ name: "NewProfile" });
    else
        return router.push({ name: "Login" });


    return next();
}
